import React, { useEffect, useState } from "react";

import { GetApp } from "@mui/icons-material";
import { Search } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/CloseOutlined"
import {TextField,InputAdornment, Box,TableRow, TableHead, TableCell, TableBody,Table, Stack, Container, IconButton, Modal, Tooltip,LinearProgress,  } from "@mui/material";

import dashboardService from '../../../services/hoa-dashboard-api-service';
interface PropertiesProps {
	selectedValues : any,
	height: number;
	emails:any;
	setEmails:any;
}

const toolbar = 64;
const filterComponent = 103;
const tabHeader = 48;
const tabHeading = 65;
const tableHeader = 57;
const responsiveHeight = toolbar + filterComponent + tableHeader + tabHeader + tabHeading + 1;

const tabWidth = ["30%", "15%", "15%", "15%", "15%", "10%"];

export default function EmailTab(props: PropertiesProps) {
	const {selectedValues, height,emails,setEmails} = props;
	const [loading, setLoading] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [downloadAbleFiles, setDownloadAbleFiles] = useState([]);
	const [modalOpen, setModalOpen] = useState(false);
	const [emailId, setEmailId] = useState(null);

	const modalClose = () => {
		setModalOpen(false);
	}

	const numberOfProjects = Math.ceil((window.innerHeight - responsiveHeight) / 60)

	const downloadDocument = async (e: any, fileName: any) => {
        e.stopPropagation();
        if(!fileName) {
            return;
        }
        let path = `hoaEmails/${fileName}`
        const documentUrl = await dashboardService.getSignedUrl(path);

        if(documentUrl && documentUrl.data) {
            window.open(String(documentUrl.data), '_blank');
        }
    }

	useEffect(()=>{
		if(emails.data.length <= 0) {
			getAssignedEmails(emails.pageNumber);
		}
	},[])

	async function handleScroll(e:any){
		const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight;
		if (bottom && !emails.isLastPage) {
			await getAssignedEmails(emails.pageNumber);
		}
	}

	async function getAssignedEmails(page: number, emailId?: string){
		if (!loading || emails.data.length < emails.count) {
			setLoading(true);
			const { status, data } = await dashboardService.getAssignedEmail(selectedValues.objectId, numberOfProjects, page, emailId ? emailId : null);
			if(status == 200) {
				const { emailList, totalCount } = data;
				if(searchQuery){
					setEmails({
						...emails,
						data: emailList,
						pageNumber: 1,
						count: totalCount,
					})
				}else{
					let isLastPage = [...emails.data, ...emailList].length >= totalCount
					setEmails({
						...emails,
						data: [...emails.data, ...emailList],
						pageNumber: emails.pageNumber+1,
						count: totalCount,
						isLastPage: isLastPage
					})
				}
			}
			setLoading(false);
		}
	}

	async function onKeyPress(e: any){
		if (e.key === "Enter") {
			setEmails({
				...emails,
				data: [],
			})
			await getAssignedEmails(1, e.target.value);
		}
	}

	return (
		<div>
			<Stack
				padding={"24px"}
				direction={"row"}
				justifyContent={"space-between"}
				alignItems={"center"}
				flexWrap={"wrap"}
				borderBottom={"1px solid #E8E8E8"}
			>
				<Box component={'span'} className="text-787878-14px bold">Assigned Emails: {emails.count}</Box>
				<SearchFieldContainer searchQuery={searchQuery} setSearchQuery = {setSearchQuery} onKeyPress={onKeyPress}/>
			</Stack>
			{loading ? <LinearProgress style={{ height: "2px", position: 'sticky', top: 0}} /> : null}
			<TableContainer 
				modalOpen={modalOpen} 
				modalClose={modalClose} 
				setModalOpen={setModalOpen} 
				setEmailId={setEmailId} 
				setDownloadAbleFiles={setDownloadAbleFiles} 
				emails={emails} 
				setEmails={setEmails} 
				loading={loading} 
				setLoading={setLoading}
				height={height}
				handleScroll={handleScroll}
			/>
			<DownloadAttachmentComp modalOpen={modalOpen} modalClose={modalClose} downloadAbleFiles={downloadAbleFiles} downloadDocument={downloadDocument}/>
		</div>
	);
}

const TableContainer = ({modalOpen, modalClose, setModalOpen, setEmailId, setDownloadAbleFiles, emails, setEmails, loading, setLoading, height, handleScroll} : any) => {

	const getFormattedDate = (dateText:string)=>{
		if(dateText) {
			const date = new Date(dateText);
			return date.toLocaleDateString();
		}
		else {
			return "N/A"
		}

	}
	const defaultNoDataContainer = () => {
		return (
			<Stack direction={"column"} justifyContent={"center"} alignItems={"center"}>
                <img style={{ width: "200px", height: "200px" }} src="images/logo/no-wallpaper.png" />
				<Box component={'span'} className="text-787878-16px bold">No email has been assigned yet</Box>
			</Stack>
		);
	};

	const onDownloadClick = (e: any, files: any, objectId: string) => {
		setDownloadAbleFiles(files);
		setEmailId(objectId);
		setModalOpen(!modalOpen);
	}

	return (
		<div style={{height:height, overflowY:"auto"}} onScroll={(e)=>{handleScroll(e)}}>
		{
			emails.data.length > 0 &&
				<Table stickyHeader>
					<TableHead>
						<TableRow
							sx={{
								"& th": {
									color: "#3E3E3E",
									backgroundColor: "#F7F7F7",
								},
							}}
						>
							{["Email Subject", "ID", "Email Type", "Date Added", "No. of Documents", ""].map(
								(title: string, index: number) => {
									return (
										<TableCell key={index} style={{width: tabWidth[index]}}>
											<span className="text-3E3E3E-14px bold">{title}</span>
										</TableCell>
									);
								}
							)}
						</TableRow>
					</TableHead>
					<TableBody>
						{
							emails.data.map((email: any, index:number)=>{
								return (
								<TableRow
									sx={{
										"& th": {
											color: "#3E3E3E",
											backgroundColor: "#F7F7F7",
										},
									}}
									key={index}
								>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{email?.subject}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{email?.objectId}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{email?.emailType}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{getFormattedDate(email?.emailServerTime)}</span>
									</TableCell>
									<TableCell >
										<span className="text-3E3E3E-14px bold">{email?.attachmentDetails ? email?.attachmentDetails.length : 0}</span>
									</TableCell>
									<TableCell>
									<Tooltip title="Download Document">
										<IconButton disabled={email?.attachmentDetails && email?.attachmentDetails.length > 0 ? false : true} onClick={(e)=>onDownloadClick(e, email?.attachmentDetails, email.objectId)}>
											<GetApp />
										</IconButton>
									</Tooltip>
									</TableCell>
								</TableRow>)
							})
						}
					</TableBody>
				</Table>
		}
		{
			emails.data.length === 0 && !loading && defaultNoDataContainer()
		}
		</div>
	);
};

// Email Attachment Download Component
const DownloadAttachmentComp = ({
	modalOpen,
	downloadAbleFiles,
	modalClose,
	downloadDocument,
}: any) => {

	const onClose = () => {
		modalClose();
	};
	return (
		<Modal disableEnforceFocus open={modalOpen} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "650px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<div style={{display: 'flex', justifyContent: 'space-between'}}>
						<h3 style={{color: '#3E3E3E'}}>Download Documents</h3>
						<IconButton
							onClick={() => onClose()}>
							<CloseIcon
								style={{cursor: "pointer"}}
							/>
						</IconButton>
					</div>
					<table className='table-container'>
						<thead style={{ margin: '0 auto' }}>
							<tr className="table-header">
								<th className="table-header-title-container">Name</th>
								<th className="table-header-title-container"></th>
							</tr>
						</thead>
						<tbody style={{ height: 'auto', width: 'auto' }}>
							{
								Array.isArray(downloadAbleFiles) && downloadAbleFiles.map((file: any, index: number) => (
									<tr className="table-body" key={index}>
										<td className="table-body-container" style={{width: '650px'}}>{file?.split('.')[1] === 'txt' ? file?.split('-')?.shift() : file?.split('-')?.pop()}</td>
										<td className="table-body-container">
											<IconButton
												onClick={(e) => {
													downloadDocument(
														e,
														file
													);
												}}>
												<GetApp
													style={{
														width: "20px",
														height: "20px",
														cursor: "pointer",
													}}
												/>
											</IconButton>
										</td>
									</tr>
								))
							}
						</tbody>
					</table>
				</div>
			</Container>
		</Modal>
	)
}

const SearchFieldContainer = ({searchQuery, setSearchQuery, onKeyPress}:any) => {

	const onEnterKeyPressed = () => {};

	return (
		<TextField
			variant="outlined"
			placeholder="Search by ID"
			onChange={(e)=>{setSearchQuery(e.target.value)}}
			onKeyDown={onEnterKeyPressed}
			name={"name"}
			style={{ boxSizing: "border-box", width: '250px' }}
			sx={{
				'&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
					borderColor: '#E8E8E8',
				  },
				  '& .MuiInputBase-root.Mui-focused fieldset': {
					borderColor: '#E8E8E8',
				  },
				  '& .MuiOutlinedInput-adornedEnd': {
					paddingRight: '0px',
				  },
			}}
			InputProps={{
				margin: "none",
				className: "mailSearchInputClass",
				startAdornment: (
					<InputAdornment position="start">
						<Search style={{ color: "#9F9F9F" }} />
					</InputAdornment>
				),
			}}
			type={"search"}
			value={searchQuery}
			onKeyPress={onKeyPress}
		/>
	);
};